<div class="faq-page max-width-lg">
  <div class="mat-headline-4 fw-700 mt-66 mb-24 primary-fg">{{ 'SOLUTION_SUMMARY.FAQ' | transloco }}</div>
  <div *ngFor="let faq of faqs; let i = index" class="faq mb-8" [ngClass]="{ 'expanded': openedIndex === i }">
    <div
      class="flex flex-row justify-between title primary-fg fw-700 cursor-pointer mat-body-1 m-0"
      (click)="toggleFaq(i)">
      {{ i + 1 }}. {{ faq.title }}
      <mat-icon [svgIcon]="openedIndex === i ? 'expand_less' : 'expand_more'"></mat-icon>
    </div>
    <div class="faq-content-wrapper">
      <div class="content primary-fg mat-body-1" [innerHTML]="faq.content"></div>
    </div>
  </div>
</div>